export const READ_QUESTIONS_MAX = 50
export const READ_TOP_QUESTIONS_MAX = 12

export const MIN_NUM_OF_QUESTION_OPTIONS = 2
export const MAX_NUM_OF_QUESTION_OPTIONS = 10

export const QUESTION_INPUT_MAX_LENGTH = 150
export const QUESTION_EXPLANATION_MIN_LENGTH = 50
export const QUESTION_EXPLANATION_MAX_LENGTH = 500
export const ANSWER_INPUT_MAX_LENGTH = 150

export const QUESTION_SEARCH_MAX_LENGTH = 150
